const detailsfileshared = (state = [], action) => {
    switch (action.type) {
      case 'DETAILSFILESHARED':
      return {
          type: "DETAILSFILESHARED",
          detailsfileshared: action.detailsfileshared
        }
      default:
        return state
    }
  }
  
  export default detailsfileshared